import * as React from 'react'

const SvgViewMode = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 16.25h15v1.25h-15v-1.25zm0-4.375h15v1.25h-15v-1.25zM16.25 3.75V7.5H3.75V3.75h12.5zm0-1.25H3.75c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25h12.5c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgViewMode
